import { render, staticRenderFns } from "./ContactDetailLoadingSekeletonComponent.vue?vue&type=template&id=b1418ffc&scoped=true&"
import script from "./ContactDetailLoadingSekeletonComponent.vue?vue&type=script&lang=js&"
export * from "./ContactDetailLoadingSekeletonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1418ffc",
  null
  
)

export default component.exports